<div class="column-centering">

  <div class="card primary dark custom-size margin-large padding-top-large padding-bottom-large">

    <div><button (click)="goToLogin()" class="margin-bottom-small full-width user-button">
        <mat-icon>login</mat-icon>
        Login with BasicNet
      </button></div>
      
    <div><button (click)="requestCredentials()" class="full-width user-button">
        <mat-icon>no_accounts</mat-icon>
        Request credentials
      </button></div>

  </div>
</div>